import { Icon } from '@iconify/react'

const ErrorState = ({ message, onRetry }) => (
    <div className="error-state" role="alert">
        <Icon icon="mdi:cloud-alert-outline" className="error-state__icon" aria-hidden="true" />
        <h2>Impossible de joindre EONET</h2>
        <p className="error-state__message">{message}</p>
        <p className="error-state__hint">
            Le service NASA est peut-être momentanément indisponible, ou la connexion a été interrompue.
        </p>
        <button type="button" className="btn btn--primary" onClick={onRetry}>
            <Icon icon="mdi:refresh" aria-hidden="true" />
            <span>Réessayer</span>
        </button>
    </div>
)

export default ErrorState
